module.exports = __webpack_public_path__ + "h5/img/support.66d74662.png";